import { createSlice } from '@reduxjs/toolkit';

const hpDataConsumptionSlice = createSlice({
  name: 'hpDataConsumption',
  initialState: {},
  reducers: {
    hpDataConsumptionHandleUnSelectIndividualMachine: (state, action) => {
      state[action.payload.location][action.payload.machine].isSelected = false;
    },
    hpDataConsumptionSpecificLocationSelectMachinesHandler: (state, action) => {
      state[action.payload.location][action.payload.specificLocation][
        action.payload.machine
      ].isSelected = true;
    },
    hpDataConsumptionHandleSelectIndividualMachine: (state, action) => {
      state[action.payload.location][action.payload.machine].isSelected = true;
    },
    hpDataConsumptionSpecificLocationUnselectMachinesHandler: (
      state,
      action
    ) => {
      state[action.payload.location][action.payload.specificLocation][
        action.payload.machine
      ] = false;
    },
  },
});

export default hpDataConsumptionSlice;
export const selectHpDataConsumption = (state) => state.hpDataConsumption;
export const {
  hpDataConsumptionHandleUnSelectIndividualMachine,
  hpDataConsumptionHandleSelectIndividualMachine,
  hpDataConsumptionSpecificLocationSelectMachinesHandler,
  hpDataConsumptionSpecificLocationUnselectMachinesHandler,
} = hpDataConsumptionSlice.actions;
